
import { sendPost } from '../http.js'
const api = {
	'getAppid': {
        url: '/open/platform'
    },
    'getSecret':{
        url:'/open/secret/reset'
    }
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = {
        mutationsName: api[key].mutationsName,
        requestFun:(params) => {
            return sendPost(api[key].url,params,api[key].method || 'post')
        }
    } 
}
export default requestFunObj
